module.exports = __webpack_public_path__ + "img/teams_fixtures.28621395.png";